import useSWR from "swr";
import { endpointsSpeckle } from "../actions/endpointsSpeckle";
import { fetcher } from "lib/actions/fetcher";
import { speckleCreateProject } from "../actions/speckleCreateProject";
import { SpeckleProjectModel } from "../../SpeckleImportWizard/types/SpeckleProjectModel";

export function useSpeckleProjects(
  speckleConnectedAccountId: number,
  workspaceId: string,
) {
  const {
    data: speckleProjects,
    error,
    isLoading,
    mutate,
  } = useSWR<SpeckleProjectModel[]>(
    speckleConnectedAccountId &&
      endpointsSpeckle.projects(speckleConnectedAccountId, workspaceId),
    fetcher,
  );

  async function create(model: Omit<SpeckleProjectModel, "id">) {
    if (!speckleConnectedAccountId) return;
    const createProjectTask = speckleCreateProject(
      speckleConnectedAccountId,
      workspaceId,
      model,
    );

    await mutate(
      async (projects) => {
        const project = await createProjectTask;
        return projects ? [...projects, project] : [project];
      },
      {
        revalidate: false,
      },
    );
    return await createProjectTask;
  }

  async function refresh() {
    await mutate();
  }

  return {
    speckleProjects,
    hasError: !!error,
    isLoading,
    create,
    refresh,
  };
}
